import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import * as XLSX from "xlsx";
import {
  Container,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Row,
  Button,
  Table,
} from "reactstrap";
import {
  fetchSelectedTeam,
  fetchTeamMembers,
  fetchTeamClientEntrantCount,
  openAddTeamMemberModal,
  updatePasswordForAll,
} from "../../../actions";
import {
  COMMON_FAIL_MESSAGE,
  CUSTOM_ITEM_COUNT,
} from "../../../../Common/constant";
import Header from "../../../../Headers/Header";
import Loader from "../../../../Common/loader";
import Pagination from "../../../../Common/pagination";
import RenderList from "./item-list";
import ViewTeamMember from "./teammember-view";
import AddTeamMember from "./teammember-add";
import LocaleStrings from "../../../../../languages";
import { CommonGoBack } from "components/Common/base-components";
import { generateRandomPassword } from "utils";
import { showSuccess, showError } from "../../../../Common/alertmessage";

const EventTeamManage = (props) => {
  const {
    session,
    deviceSize,
    SelectedTeam,
    teamClientEntrantCount,
    SelectedTeamMembers,
    ViewTeamMembers,
    AddTeamMembers,
  } = props;

  const [pageNumber, setPageNumber] = useState(1);
  const [generating, setGenerating] = useState(false);
  const eventid = props?.match?.params?.eventid ?? SelectedTeam?.eventidfk;
  const teamid = props?.match?.params?.teamid ?? SelectedTeam?.id;

  useEffect(() => {
    props.fetchTeamMembers(session, eventid, teamid);
    props.fetchTeamClientEntrantCount(session, teamid, (res) => {
      props.fetchSelectedTeam(session, teamid);
    });
  }, [teamid]);

  const openAddTeam = () => {
    props.openAddTeamMemberModal({ showModal: true });
  };

  const additionCallback = () => {
    paginationCallback(pageNumber);
    props.fetchTeamClientEntrantCount(session, teamid);
  };

  const paginationCallback = (pageNum) => {
    props.fetchTeamMembers(session, eventid, teamid, pageNum, (response) => {});

    setPageNumber(pageNum);
  };

  const handleRegeneratePasswordForAll = () => {
    const payload = [];
    _.map(SelectedTeamMembers?.data, (mem) => {
      if (!mem?.withdrawndate)
        payload.push({ id: mem?.dfid, password: generateRandomPassword() });
    });

    setGenerating(true);
    props.updatePasswordForAll(session, payload, (res) => {
      setGenerating(false);
      if (res?.success) {
        showSuccess(LocaleStrings.events_team_csv_download_alert_success);
        handleCSVGenerate(payload);
      } else {
        showError(COMMON_FAIL_MESSAGE);
      }
    });
  };

  const handleCSVGenerate = (passwords) => {
    const JSONData = [
      [
        LocaleStrings.events_teammember_view_text_fname,
        LocaleStrings.events_teammember_view_text_lname,
        LocaleStrings.events_teammember_view_text_manager,
        LocaleStrings.events_teammember_form_label_gender,
        LocaleStrings.events_teammember_view_text_uname,
        LocaleStrings.events_teammember_view_text_password,
      ],
    ];
    _.map(SelectedTeamMembers?.data, (mem) => {
      const found = _.find(passwords, (pm) => pm?.id === mem?.dfid);
      if (found) {
        JSONData.push([
          mem?.firstname,
          mem?.lastname,
          mem?.membertype === "teacher",
          _.startCase(mem?.gender),
          mem?.username,
          found?.password,
        ]);
      }
    });

    /* Create a new empty workbook, then add the worksheet */
    let wb = XLSX.utils.book_new();
    var ws = XLSX.utils.aoa_to_sheet(JSONData);
    var sheetName = "Sheet 1";

    XLSX.utils.book_append_sheet(wb, ws, sheetName);

    /* Generate xlsx files */
    XLSX.writeFile(wb, `Passwords_for_team_${teamid}.xlsx`);
  };

  const _renderList = () => {
    let pageDataLength = SelectedTeamMembers?.data
      ? SelectedTeamMembers?.data?.length
      : 0;

    return _.map(SelectedTeamMembers.data, (item, index) => {
      return (
        <RenderList
          key={`key_${index}`}
          printList={item}
          pageDataLength={pageDataLength}
          currentPage={pageNumber}
          pagination={paginationCallback}
          teamid={teamid}
        />
      );
    });
  };

  return (
    <>
      <Header />

      {/* Page content */}
      <Container className="mt--5" fluid>
        <CommonGoBack />
        <Row>
          <div className="col">
            <Card className="shadow border-0">
              <CardHeader className="">
                <div className="pull-left">
                  <h4>
                    {!_.isEmpty(SelectedTeam)
                      ? `${SelectedTeam?.event_by_eventidfk?.name ?? ""} > ${
                          SelectedTeam?.teamname
                        }`
                      : ""}
                  </h4>
                </div>
                <div className="pull-right">
                  {/* Add Entrant */}
                  {SelectedTeam?.withdrawndate ? (
                    ""
                  ) : (
                    <>
                      {/* Password regenerate button */}
                      <Button
                        className=""
                        color="primary"
                        size="sm"
                        onClick={handleRegeneratePasswordForAll}
                      >
                        {generating ? (
                          <i className="fa fa-refresh fa-spin"></i>
                        ) : (
                          ""
                        )}{" "}
                        {LocaleStrings.button_generate_team_passwords}
                      </Button>

                      {/* Add entrant */}
                      {SelectedTeam?.eventclient_by_eventclientidfk
                        ?.maxteammember >
                        teamClientEntrantCount?.data?.teamentrantcount &&
                      SelectedTeam?.eventclient_by_eventclientidfk
                        ?.totalmembers >
                        teamClientEntrantCount?.data?.cliententrantcount ? (
                        <Button
                          className=""
                          color="primary"
                          size="sm"
                          onClick={openAddTeam}
                        >
                          {LocaleStrings.button_add_team_member}
                        </Button>
                      ) : (
                        <Button
                          className=""
                          color="primary"
                          size="sm"
                          disabled={true}
                        >
                          {LocaleStrings.events_teammember_text_team_size_full}
                        </Button>
                      )}
                    </>
                  )}
                  {/* {SelectedTeam?.withdrawndate ? (
                    ""
                  ) : (
                    <Button
                      className=""
                      color="primary"
                      size="sm"
                      onClick={openAddTeam}
                    >
                      {LocaleStrings.button_add_team_member}
                    </Button>
                  )} */}
                  {/* <Button className="" color="primary" size="sm">
                    {LocaleStrings.button_copy_parent_link}
                  </Button>
                  <Button className="" color="primary" size="sm">
                    {LocaleStrings.button_export}
                  </Button> */}
                </div>
              </CardHeader>

              <CardBody style={{ height: deviceSize.height }}>
                {SelectedTeamMembers?.data ? (
                  <>
                    {SelectedTeamMembers?.count > 0 ? (
                      <Table
                        className="align-items-center table-flush"
                        responsive
                      >
                        <thead className="thead-light">
                          <tr>
                            <th scope="col">
                              {LocaleStrings.events_teammember_th_id}
                            </th>
                            <th scope="col">
                              {LocaleStrings.events_teammember_th_fname}
                            </th>
                            <th scope="col">
                              {LocaleStrings.events_teammember_th_lname}
                            </th>
                            <th scope="col">
                              {LocaleStrings.events_teammember_th_uname}
                            </th>
                            <th scope="col" />
                          </tr>
                        </thead>
                        <tbody>{_renderList()}</tbody>
                      </Table>
                    ) : (
                      <div className="no-content-message">
                        <div>
                          <div className="no-content-text">
                            {LocaleStrings.events_teammember_text_no_data}
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <Loader />
                )}

                {SelectedTeamMembers?.count > CUSTOM_ITEM_COUNT ? (
                  <CardFooter className="">
                    <Pagination
                      activePage={pageNumber}
                      itemsCountPerPage={CUSTOM_ITEM_COUNT}
                      totalItemsCount={SelectedTeamMembers?.count}
                      pageRangeDisplayed={3}
                      onChange={paginationCallback}
                    />
                  </CardFooter>
                ) : (
                  ""
                )}
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>

      {ViewTeamMembers?.showModal ? <ViewTeamMember /> : ""}
      {AddTeamMembers?.showModal ? (
        <AddTeamMember
          finishOperationsCallback={additionCallback}
          teamid={teamid}
        />
      ) : (
        ""
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    session: state.session,
    deviceSize: state.deviceSize,
    SelectedTeam: state.SelectedTeam,
    teamClientEntrantCount: state.teamClientEntrantCount,
    SelectedTeamMembers: state.SelectedTeamMembers,
    ViewTeamMembers: state.ViewTeamMembers,
    AddTeamMembers: state.AddTeamMembers,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchSelectedTeam,
      fetchTeamMembers,
      fetchTeamClientEntrantCount,
      openAddTeamMemberModal,
      updatePasswordForAll,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(EventTeamManage);
